import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from "lexical";
import { $createImageNode, ImageNode } from "./image-node";

/** Command payload for inserting an image. */

/** Command to insert an image into the editor. */
export var INSERT_IMAGE_COMMAND = createCommand("INSERT_IMAGE_COMMAND");

/** Registers the insert-image command handler. */
export function ImagesPlugin() {
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  useEffect(function () {
    if (!editor.hasNodes([ImageNode])) return undefined;
    return editor.registerCommand(INSERT_IMAGE_COMMAND, function (payload) {
      editor.update(function () {
        $insertNodes([$createImageNode(payload.src, payload.altText)]);
      });
      return true;
    }, COMMAND_PRIORITY_EDITOR);
  }, [editor]);
  return null;
}